import color from "../../../../constants/color";

const styles = {
  noShadow:{
    boxShadow:"none"
  },
  pagination:{
    width:"100%",
    "& .MuiTablePagination-spacer":{
      display:"none"},
    "& .MuiInputBase-root":{
      border:" 1px solid #E5E5E5",
      borderRadius:"30px",
      px:1}
  },

  dateInput: {
    width: "100%",
    mt:1,

    // padding:2,
    "& .css-6193sp-MuiInputBase-root-MuiOutlinedInput-root ": {
      borderRadius: "8px",
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },

  tableHead: {
    color: color.lightText,
    fontWeight: "400",
    whiteSpace: "nowrap",
    overflow: "hidden", 

  },
  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"0px 14px",

    },
    "& .MuiOutlinedInput-root":{
      padding:"0",
      borderRadius:"70px",

      
    }
  },
  modalInputs:{
    display:"flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
  },
  inputSpace: {
    "& .MuiOutlinedInput-root":{
      padding:"0px 14px"
    }

  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text,
  },
  tableData: {
    borderBottom: "0",
    textTransform:"capitalize",
    whiteSpace: "nowrap",
    overflow: "hidden", 

  },
  profileData: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center" 
  },
  name:{
    
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize"

  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },
  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    // justifyContent: "center",  
  },
  deleteIcon: {
    color: "#ff0000",
    // mb:1,
    ml:2,
  },
  exportBtn: {
    borderRadius: 50,
    color: color.secondary,
    border: "1px solid #00ABF4",
    backgroundColor: "transparent",
    ml: "19px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none",
    py: "4px",
    px: "8px",
    "&:hover": {
      border: "1px solid #00ABF4",
      backgroundColor: "transparent",
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: "transparent",
    },
    "& .MuiLoadingButton-loadingIndicator": {
      color: color.secondary,
    },
    "& .MuiButton-startIcon": {
      mr: "4px",
    },
    "& svg": {
      mr: 0,
    },
  },

  filterPanel: {
    width: "260px",
    px: 2,
    pb: 2,
    pt: 1,
    borderTop: "1px solid #E5E5E5",
  },
  filterPanelLabel: {
    fontSize: "12px",
    color: color.lightText,
    mt: 1,
    mb: 0.5,
  },
  filterPanelInput: {
    fontSize: "12px",
    "& .MuiInputBase-root": { borderRadius: "8px", fontSize: "12px" },
    "&.MuiInputBase-root": { borderRadius: "8px" },
  },
  filterPanelActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
    mt: 2,
  },
  filterPanelClear: {
    textTransform: "none",
    color: "#28AA4A",
    borderRadius: 50,
  },
  filterPanelApply: {
    textTransform: "none",
    backgroundColor: "#28AA4A",
    borderRadius: 50,
    boxShadow: "none",
    "&:hover": { backgroundColor: "#28AA4A" },
  },
};
export default styles;
